import { NumberOfGuestsSelection } from './types';

export const ADULTS = 'adults';
export const CHILDREN = 'children';

export const OCCUPANCY_TYPE = 'OcupancyFilter';

export const DEFAULT_COUNT = 0;
export const DEFAULT_MIN_COUNT = 0;
export const DEFAULT_MAX_COUNT = 10;

export const DEFAULT_MIN_ADULTS = 1;
export const DEFAULT_INITIAL_ADULTS = 2;
export const DEFAULT_MIN_CHILDREN = 0;
export const DEFAULT_INITIAL_CHILDREN = 0;
export const DEFAULT_MAX_TOTAL_GUESTS = 4;
export const DEFAULT_ANCHOR_GAP = 0;

export const DEFAULT_OCCUPANCY: NumberOfGuestsSelection = {
	adults: DEFAULT_INITIAL_ADULTS,
	children: DEFAULT_INITIAL_CHILDREN,
};
